/*
 * Name: Product Card
 * Desc:
 *
 */
import React, { useState } from "react"
import * as styles from "./ProductCard.module.scss"

const Summary = ({ title, price, priceUpper, category = [], brand = [] }) => (
  <div className={styles.Summary}>
    <h4 className={styles.title}>{title}</h4>
    <div className={styles.subtitle}>
      <span className={styles.brand}>{brand ? brand[0]?.title : ""}</span>
      {category && category[0] ? (
        <>
          <span className={styles.separator}>|</span>
          <span className={styles.category}>{category[0].title}</span>
        </>
      ) : null}
    </div>

    {price ? (
      <div className={styles.price}>
        £{price.toLocaleString()}
        {priceUpper ? ` - £${priceUpper.toLocaleString()}` : ""}
      </div>
    ) : null}
  </div>
)

const ProductCard = (props) => {
  const { link, image } = props

  return (
    <div className={`${styles.ProductCard} ${styles.loaded}`}>
      <a href={link} target="_blank" rel="noopener noreferrer nofollow">
        <div className={styles.image}>
          <img className={styles.img} src={image} alt="" />
        </div>
        <Summary {...props} />
      </a>
    </div>
  )
}

export default ProductCard
